import axios from "../../utils/axiosConfig";
import { GetClinicAppointmentStatsDTO } from "../../dtos/dashboard";
function removeSpacesFromUrl(url: string): string {
  const urlComponents = url.split("/");
  for (let i = 0; i < urlComponents.length; i++) {
    urlComponents[i] = urlComponents[i].replace(/\s/g, "");
  }
  return urlComponents.join("/");
}
axios.defaults.withCredentials = true;
const getClinicStats = async (clinicId: string) => {
  const url =  `/api/clinic/stats/get?clinic_id=${clinicId}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};
const getClinicAppointmentsStats = async (
  dto: GetClinicAppointmentStatsDTO
) => {
  const url =
    
    `/api/clinic/appointments/stats/get/v1?clinic_id=${dto.clinic_id}&duration=${dto.duration}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};

const dashboardService = {
  getClinicStats,
  getClinicAppointmentsStats,
};

export default dashboardService;
